import { useEffect, useState } from 'react';
import { subscribe, flush } from '../lib/outbox';

// Плашка видна, только пока есть неотправленные изменения.
export const APP_VERSION = 'v110';

export default function SaveStatus() {
  const [st, setSt] = useState({ pending: 0, flushing: false, lastError: '' });
  useEffect(() => subscribe(setSt), []);
  const stamp = <div style={{ position: 'fixed', right: 8, bottom: 4, zIndex: 400, fontSize: 10, color: '#A0AEC0', pointerEvents: 'none' }}>{APP_VERSION}</div>;
  if (!st.pending) return stamp;
  const sending = st.flushing;
  return (
    <>
    {stamp}
    <div style={{
      position: 'fixed', left: 12, bottom: 12, zIndex: 500, maxWidth: 340,
      background: sending ? '#EBF4FF' : '#FFF1F2', border: `1px solid ${sending ? '#BBD6EE' : '#F3B5BC'}`,
      color: sending ? '#1F3864' : '#9C0006', borderRadius: 10, padding: '10px 12px',
      boxShadow: '0 4px 16px rgba(0,0,0,.18)', fontSize: 12, lineHeight: 1.45,
    }}>
      <div style={{ fontWeight: 700 }}>
        {sending ? `Сохраняется… (${st.pending})` : `Не сохранено: ${st.pending}`}
      </div>
      {(st.labels || []).map((l, i) => <div key={i} style={{ fontSize: 11, opacity: .9 }}>• {l}</div>)}
      {!sending && (
        <>
          <div style={{ marginTop: 2 }}>Изменения не потеряны, отправляем повторно. Не закрывайте страницу.</div>
          <button onClick={() => flush()} style={{ marginTop: 6, fontSize: 12, fontWeight: 600, padding: '4px 10px', borderRadius: 6, border: '1px solid #F3B5BC', background: '#fff', color: '#9C0006', cursor: 'pointer' }}>Отправить сейчас</button>
        </>
      )}
    </div>
    </>
  );
}
